import { Modal } from '@lms/ui';
import { QuestionAttemptPreview } from './QuestionAttemptPreview';
import type { QuestionOptionDraft } from './questionEditor';

export interface QuestionPreviewModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  stem: string;
  type: string;
  typeLabel: string;
  options: QuestionOptionDraft[];
}

export function QuestionPreviewModal({
  open,
  onClose,
  title,
  stem,
  type,
  typeLabel,
  options,
}: QuestionPreviewModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Vista previa"
      description="Así verá el estudiante esta pregunta dentro de una evaluación."
      size="lg"
    >
      <div className="lms-question-preview">
        <p className="lms-question-preview__meta">
          <span>{typeLabel}</span>
          {title.trim() ? <span>{title.trim()}</span> : null}
        </p>
        <QuestionAttemptPreview stem={stem} type={type} options={options} />
        <p className="lms-question-preview__hint">
          Refleja el contenido actual del formulario, incluso si aún no has guardado.
        </p>
      </div>
    </Modal>
  );
}
